import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/icons/he-IL.png'
import _imports_1 from '@/assets/icons/en-US.png'
import _imports_2 from '@/assets/icons/ru-RU.png'


const _withScopeId = n => (_pushScopeId("data-v-869300d0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "d-flex justify-content-end" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(["my-auto", { active: $setup.locale == 'he-IL' }])
    }, [
      _createElementVNode("img", {
        class: "language-image",
        src: _imports_0,
        onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.changeLang('he-IL')))
      })
    ], 2),
    _createElementVNode("div", {
      class: _normalizeClass(["m-2 my-auto", { active: $setup.locale == 'en-US' }])
    }, [
      _createElementVNode("img", {
        class: "language-image",
        src: _imports_1,
        onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.changeLang('en-US')))
      })
    ], 2),
    _createElementVNode("div", {
      class: _normalizeClass(["my-auto", { active: $setup.locale == 'ru-RU' }])
    }, [
      _createElementVNode("img", {
        class: "language-image",
        src: _imports_2,
        onClick: _cache[2] || (_cache[2] = ($event: any) => ($setup.changeLang('ru-RU')))
      })
    ], 2)
  ]))
}